import { useEffect } from "react";
import { useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const LocationFinder = ({ goToPosition, onAddPoint, stopGoToPosition }) => {
    const map = useMap();

    useEffect(() => {
        if (!goToPosition) return;

        const locateOptions = {
            setView: true,
            maxZoom: 19,
            enableHighAccuracy: true,
        };

        const onLocationFound = (e) => {
            const { latlng } = e;
            const zoomLevel = 19;
            setTimeout(() => {
                map.flyTo(latlng, zoomLevel);
            }, 0);
            onAddPoint?.(latlng);
            stopGoToPosition();
        };

        const onLocationError = () => {
            alert("Αδυναμία Εύρευσης της τοποθεσίας σας.");
            stopGoToPosition();
        };
        map.once("locationfound", onLocationFound);
        map.once("locationerror", onLocationError);

        map.locate(locateOptions);

    }, [goToPosition, map, onAddPoint, stopGoToPosition]);

    return null;
};

export default LocationFinder;
